var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yo-widget',[_c('div',{staticClass:"full",attrs:{"slot":"content"},slot:"content"},[_c('yogui2',{staticClass:"full",attrs:{"earthID":_vm.earthID,"ownerID":_vm.ownerID},on:{"switch":function (v) { _vm.$emit('switch', v) }}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }